/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/image/css/definition/content/image.css */
@layer image.definition.content.image {
  :host {
    display: block;
    width: auto;
    height: auto;
    max-height: auto;
    max-width: 100%;
    border-radius: initial;
  }
  .image,
  img {
    width: inherit;
    max-width: inherit;
    height: inherit;
    max-height: inherit;
    border-radius: inherit;
  }
}

/* src/primitives/image/css/definition/variations/aligned.css */
@layer image.definition.variations.aligned;

/* src/primitives/image/css/definition/image-definition.css */

/* src/primitives/image/css/theme/content/image-variables.css */
@layer image.theme.content.image {
  :host {
  }
}

/* src/primitives/image/css/theme/variations/aligned-variables.css */
@layer image.theme.variations.aligned;

/* src/primitives/image/css/theme/image-theme.css */

/* src/primitives/image/css/image.css */
